/* eslint-disable max-lines-per-function */
import { TerminImage } from '@/domain/termine/components/TerminImage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Termin } from '@/domain/termine/shared/types/Termin';
import dayjs from 'dayjs';
import {
  getWiederholungStringFromTerminWiederholung,
  TerminWiederholung,
} from '@/domain/termine/shared/types/TerminWiederholung';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { TerminPopover } from '@/domain/termine/features/Calendar/Grid/Termin/TerminPopover';
import { useDayPopover } from '@/domain/termine/features/Calendar/Grid/DayCell/Popover/DayPopoverContext';
import { faArrowsRepeat } from '@fortawesome/pro-regular-svg-icons';

export function TerminEntry({
  termine,
  ...divProps
}: {
  termine: Termin[];
} & React.HTMLAttributes<HTMLDivElement>) {
  const { t } = useTranslation();
  const fromDayPopover = useDayPopover();

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div
      className="flex flex-col py-1 gap-1"
      onClick={handleClick}
      {...divProps}>
      {termine.map((termin) => (
        <TerminPopover key={termin.id} termin={termin}>
          <div
            className={cn(
              'p-2 rounded-md text-xs text-left w-full flex',
              'items-center gap-2 truncate bg-none cursor-pointer',
              fromDayPopover ? 'hover:bg-neutrals-N200' : 'bg-neutrals-N200',
            )}
            title={termin.titel}>
            <TerminImage
              bildUrl={termin.image?.url}
              bildName={termin.image?.name}
              markierung={termin.markierung}
              variant="list"
            />
            <div className="flex flex-col flex-1 min-w-0">
              <span className="truncate">{termin.titel}</span>
            </div>
            <span className="text-neutrals-N800 flex items-center gap-1 truncate">
              {termin.beginn && dayjs(termin.beginn).format('HH:mm')}
              {termin.wiederholung !== TerminWiederholung.OHNE && (
                <FontAwesomeIcon
                  icon={faArrowsRepeat}
                  title={`${t('domain.termine.repeat', {
                    wiederholung: termin.wiederholung,
                  })} ${getWiederholungStringFromTerminWiederholung(
                    termin.wiederholung,
                  ).toLowerCase()}`}
                />
              )}
            </span>
          </div>
        </TerminPopover>
      ))}
    </div>
  );
}
